var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lightblue-text-btn ml-8"},[_c('el-button',{attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.handelPrimaryBtn}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }